export default __webpack_public_path__ + "static/cp-website-b4849ad48dc3328a89080ce8877dfca4.jpg";